import type { DemoEnvironment, EnvironmentUtils } from '@change-corgi/core/environment';
import { createEnvironmentUtils as _createEnvironmentUtils } from '@change-corgi/core/environment';
import { getLocation, getWindow } from '@change-corgi/core/window';

import webappInfo from 'src/webappInfo';

declare global {
	// oxlint-disable-next-line @typescript-eslint/consistent-type-definitions
	interface Window {
		// oxlint-disable-next-line @typescript-eslint/naming-convention
		DEMO_ENV_TARGET?: DemoEnvironment;
	}
}

export function createEnvironmentUtils(): EnvironmentUtils {
	const { hostname } = getLocation();

	return _createEnvironmentUtils({
		hostname,
		buildEnvironment: process.env.NODE_ENV,
		demoEnvironmentTarget: getWindow().DEMO_ENV_TARGET,
		apiEnvironment: webappInfo.proxyTarget?.env,
		apiDemoEnvironment: webappInfo.proxyTarget?.demoEnv,
	});
}
